<template>
	<b-modal
		:title="`${driverName}`"
		id="driver-license-image-view"
		:no-close-on-backdrop="true"
		size="md"
		:hide-footer="true"
		centered
	>
		<b-row>
			<b-col sm="12">
				<div align="center">
					<b-img
						v-img-orientation-changer
						:src="driver.licenseUrl"
						alt="Responsive image"
						class="img-responsive"
						fluid
					/>
				</div>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
// Others
import EventBus from '@/shared/event-bus';
import _ from 'lodash';

export default {
	name: 'DriversLicenseImageView',
	data() {
		return {
			driver: {},
		};
	},
	computed: {
		driverName() {
			if (!_.isEmpty(this.driver) && !_.isEmpty(this.driver.name)) {
				return this.driver.name;
			}
			return '';
		},
	},
	mounted() {
		EventBus.$on('onSelDriversLicenseImageView', (data) => {
			this.driver = data.driver;
		});
	},
	beforeDestroy() {
		EventBus.$off('onSelDriversLicenseImageView');
	},
};
</script>

<style scoped>
.thumbnail {
	position: relative;
}
.caption {
	position: absolute;
	bottom: 0px;
	left: -10px;
	width: 100%;
}
.strokeme {
	color: white;
	text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
		1px 1px 0 #000;
}
</style>